import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-error-landing-page',
  templateUrl: './error-landing-page.component.html',
  styleUrls: ['./error-landing-page.component.scss']
})
export class ErrorLandingPageComponent implements OnInit {

	errorMessage: any;
	constructor(
		private route: ActivatedRoute,
		public router: Router
	) { }

	ngOnInit(): void {
		const type = this.route.snapshot.paramMap.get('type');

		if (type == 'expiredlink') {
			this.errorMessage = 'This link has expired. Please contact your advisor for a new link.';
		} else {
			this.errorMessage = 'Unfortunately Something went wrong. Please try again.';
		}
	}

	gotoLogin() {
		this.router.navigate(['/login']);
	}

}
